module.exports = __webpack_public_path__ + "static/media/flow-chart.db594377.png";